import { put, takeLatest } from 'redux-saga/effects';
import { SOCKET_MESSAGE } from 'sockets-middleware/consts';
import { getUserFlags } from '../userFlags/actionCreators';
import { getUserStatus } from '../userLogin/actionCreators';
export function* reactToSockets(action) {
    var _a;
    const responseType = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.type;
    if (!responseType) {
        return;
    }
    switch (responseType) {
        case 'request_should_call_user_flags':
            yield put(getUserFlags());
            break;
        case 'request_should_call_user_status':
            yield put(getUserStatus());
            break;
    }
}
export function* watchReactToSocketCalls() {
    yield takeLatest(`cloud/${SOCKET_MESSAGE}`, reactToSockets);
}
//# sourceMappingURL=saga.js.map